import { render, staticRenderFns } from "./IconVoucher.vue?vue&type=template&id=760106a5&"
import script from "./IconVoucher.vue?vue&type=script&lang=ts&"
export * from "./IconVoucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports